import {getLocation} from './location';
import {AdServer} from '../domain/AdServer';

export const PLACEMENT_QUERY_PARAM_BASE = 'advert_override_placement';
export const CREATIVE_ID_QUERY_PARAM_BASE = 'advert_force_creative';
export const AD_SERVER_QUERY_PARAM = 'advert_force_adserver';

const placements = parseUrlParamsPerAdServer(PLACEMENT_QUERY_PARAM_BASE),
	creativeIds = parseUrlParamsPerAdServer(CREATIVE_ID_QUERY_PARAM_BASE),
	adServerOverrides = parseUrlParams(AD_SERVER_QUERY_PARAM);

function parseUrlParamsPerAdServer(baseKey: string): Partial<Record<AdServer, Record<string, string>>> {
	return [...new URLSearchParams(getLocation().search)]
		.filter(([key]) => key.startsWith(baseKey))
		.map(([key, value]) => {
			const adServer = key.slice(baseKey.length + 1);

			return [
				adServer ? adServer : AdServer.Xandr,
				parseSlotValues(value)
			];
		})
		.reduce((agg, [adServer, slotMappings]:  [AdServer, Record<string, string>]) => {
			agg[adServer] ??= {};
			Object.assign(agg[adServer], slotMappings);

			return agg;
		}, {} as Partial<Record<AdServer, Record<string, string>>>);
}
function parseUrlParams(key: string): Record<string, string> {
	const param = new URLSearchParams(getLocation().search).get(key);

	return parseSlotValues(param);
}

function parseSlotValues(input: string | null): Record<string, string> {
	return Object.fromEntries(input?.split(',').map(v => v.split(':')) ?? []);
}

export function getForcedCreativeId(slotName: string, adServer: AdServer): string | null {
	return creativeIds[adServer]?.[slotName] ?? creativeIds[adServer]?.['*'] ?? null;
}

export function getPlacementOverride(slotName: string, adServer: AdServer): string | null {
	return placements[adServer]?.[slotName] ?? placements[adServer]?.['*'] ?? null;
}

export function getForcedAdServer(slotName: string): string | null {
	return adServerOverrides[slotName] ?? adServerOverrides['*'] ?? null;
}

export function getPlacementOverrides(): Partial<Record<AdServer, Record<string, string>>> {
	return placements;
}

export function getCreativeIdOverrides(): Partial<Record<AdServer, Record<string, string>>> {
	return creativeIds;
}

export function getAdServerOverrides(): Record<string, string> {
	return adServerOverrides;
}
